export default __webpack_public_path__ + "static/media/malt_stage.8156f177.png";